import computerApi from '../../api/computerApi'

const state = {
    computers: [],
    computer: {}
}

const getters = {}

const actions = {
    async getComputers({ commit }) {
        const res = await computerApi.all()
            .catch(err => {
                console.log(err)
                return false
            })

        if (res.status === 200) {
            commit('SET_COMPUTERS', res.data)
            return true
        }
    },

    async createComputer({ commit }, computer) {
        const res = await computerApi.store(computer)
            .catch(err => {
                console.log(err)
                return false
            })

        if (res.status === 201) {
            commit('CREATE_COMPUTER', computer)
            return true
        }
    },

    async getComputerById({ commit }, computerID) {
        const res = await computerApi.show(computerID)
            .catch(err => {
                console.log(err)
                return false
            })

        if (res.status === 200) {
            // console.log(res.data);
            commit('GET_COMPUTER', res.data)
            return true
        }
    },

    async updateComputer({ commit }, computer) {
        const res = await computerApi.update(computer)
            .catch(err => {
                console.log(err)
                return false
            })

        if (res.status === 201) {
            commit('UPDATE_COMPUTER', res.data)
            return true
        }
    },

    async deleteComputer({ commit }, computerID) {
        const res = await computerApi.delete(computerID)
            .catch(err => {
                console.log(err);
                return false;
            });

        if (res.status === 200) {
            commit('DELETE_COMPUTER', computerID);
            return true;
        }
    }
}

const mutations = {
    SET_COMPUTERS: (state, computers) => state.computers = computers,

    GET_COMPUTER: (state, computer) => state.computer = computer,
    EMPTY_COMPUTER: (state) => state.computer = {},

    CREATE_COMPUTER: (state, computer) => state.computers.unshift(computer),

    UPDATE_COMPUTER: (state, computer) => {
        const index = state.computers.findIndex(computer => computer.id === computer.id);

        if (index !== -1) {
            state.computers.splice(index, 1, computer);
        }
    },

    DELETE_COMPUTER: (state, computerID) => {
        state.computers = state.computers.filter(computer => computer.id === computerID);
    },
}

export default { state, actions, getters, mutations }